exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kng-profile-panel .kng-profile-photos .kng-profile-photo-default {\n  background-color: #253b56;\n  color: #fff;\n}\n.kng-profile-panel .kng-profile-photos .kng-profile-photo-default .initials {\n  margin-top: 25%;\n}\n.kng-profile-panel .kng-panel {\n  box-shadow: none;\n  -webkit-box-shadow: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/kng-profile/kng-profile.component.less
// module id = ../../../../../src/app/layout/kingswell/kng-profile/kng-profile.component.less
// module chunks = main